import update from 'immutability-helper';
import {
    SET_AGENCY_SIGNUP_STATUS,
    SET_AGENCY_SIGNUP_IS_LOADING,
    SET_AGENCY_SIGNUP_EMAIL_SENT,
    SET_AGENCY_NAME_AVAILABLE,
} from './actions';

const initialState = {
    status: null,
    errorCode: null,
    isLoading: false,
    emailSent: false,
    nameAvailable: null,
};

export default function agencySignupReducer(state = initialState, action) {
    switch (action.type) {
        case SET_AGENCY_SIGNUP_STATUS:
            return update(state, {
                status: { $set: action.status },
                errorCode: { $set: action.errorCode },
            });
        case SET_AGENCY_SIGNUP_IS_LOADING:
            return update(state, {
                isLoading: { $set: action.isLoading },
            });
        case SET_AGENCY_SIGNUP_EMAIL_SENT:
            return update(state, {
                emailSent: { $set: action.emailSent },
            });
        case SET_AGENCY_NAME_AVAILABLE:
            return update(state, {
                nameAvailable: { $set: action.nameAvailable },
            });
        default:
            return state;
    }
}
